/**
 * Composable for calculating shipping time estimates with weekend handling
 * @returns shippingTime reactive object with min/max formatted dates and days
 */
export function useShippingTime() {
  const runtimeConfig = useRuntimeConfig()
  const { d } = useI18n()
  const now = useState(() => new Date())

  const shippingTime = computed(() => {
    const calculateDate = (days: number) => {
      const date = new Date(now.value.getTime() + days * 24 * 60 * 60 * 1000)

      // Skip to Monday if the date falls on a weekend
      const dayOfWeek = date.getDay()
      if (dayOfWeek === 0) { // Sunday
        date.setDate(date.getDate() + 1)
      }
      else if (dayOfWeek === 6) { // Saturday
        date.setDate(date.getDate() + 2)
      }

      return d(date, {
        weekday: 'short',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    }

    return {
      min: calculateDate(+runtimeConfig.public.expressShippingTime.min),
      max: calculateDate(+runtimeConfig.public.expressShippingTime.max),
    }
  })

  const shippingTimeDays = computed(() => {
    return {
      min: +runtimeConfig.public.expressShippingTime.min,
      max: +runtimeConfig.public.expressShippingTime.max,
    }
  })

  return {
    shippingTime,
    shippingTimeDays,
  }
}
